import { Steps } from '../../../..'
import { Options } from './interfaces'

export function isReScheduleStep(options: Options) {
  const { step } = options
  return step === Steps.Reschedule
}
